import { NgbDateAdapter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { Moment } from 'moment';
import { Injectable } from '@angular/core';

/**Adapts datepicker from NgbDateStruct to Moment.*/
@Injectable()
export class NgbMomentAdapter extends NgbDateAdapter<Moment> {
  static fromMoment(value: Moment): NgbDateStruct {
    let convertedValue = null;
    if (value) {
      convertedValue = { year: value.year(), month: value.month() + 1, day: value.date() };
    }
    return convertedValue;
  }

  static fromDate(value: Date): NgbDateStruct {
    let convertedValue = null;
    if (value) {
      convertedValue = { year: value.getUTCFullYear(), month: value.getUTCMonth() + 1, day: value.getUTCDate() };
    }
    return convertedValue;
  }

  static toMoment(date: NgbDateStruct): Moment {
    let convertedValue = null;
    if (date) {
      convertedValue = moment.utc({ year: date.year, month: date.month - 1, day: date.day});
    }
    return convertedValue;
  }

  fromModel(value: Moment): NgbDateStruct {
    if (typeof value !== 'string') {
      try {
        return NgbMomentAdapter.fromMoment(value);
      } catch {
        return NgbMomentAdapter.fromDate(value as any);
      }
    } else {
      return value;
    }
  }

  toModel(date: NgbDateStruct): Moment {
    if (typeof date !== 'string') {
      return NgbMomentAdapter.toMoment(date);
    } else {
      return date;
    }
  }
}
